// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"6ace4406","379":"6e132339"}[chunkId] + ".chunk.css";
};